import { LOGIN_MAPPED_ON_LIVE } from 'constants/index';

export default {
  __html: `(function(g, r, o, w, t, h, rx) {
        g[t] =
          g[t] ||
          function() {
            (g[t].q = g[t].q || []).push(arguments);
          };
        g[t].l = 1 * new Date();
        g[t] = g[t] || {};
        window.TimesApps = window.TimesApps || {};
        const { TimesApps } = window;
        TimesApps.loadTpSdk = TimesApps.loadTpSdk || function() { 
            (function(g, r, o, w, t, h, rx) {
                g[t] =
                  g[t] ||
                  function() {
                    (g[t].q = g[t].q || []).push(arguments);
                  };
                g[t].l = 1 * new Date();
                g[t] = g[t] || {};
                h = r.createElement(o);
                rx = r.getElementsByTagName(o)[0];
                h.async = 1;
                h.defer = 1;
                h.src = w;
                if (
                  window.TimesGDPR &&
                  window.TimesGDPR.common.consentModule.gdprCallback
                ) {
                  window.TimesGDPR.common.consentModule.gdprCallback((data)=>{
                    if(!data.isEUuser || data.consentGiven){
                      rx.parentNode.insertBefore(h, rx);
                    }
                  })
                }
            })(g, r, o, w, t, h, rx);
        }
      })(
        window,
        document,
        'script',
        'https://${
          !(LOGIN_MAPPED_ON_LIVE || __PROD__)
            ? 'test-img.timespoints.com'
            : 'image.timespoints.iimg.in'
        }/static/tpsdk/tp-sdk.js',
        'tpsdk',
      );`,
};
